(function ($) {
  /* Start Calculator */
  $(document).ready(function () {
    const mutualFundPathName = 'mutual-fund-return';
    let path = location.pathname.split('/').filter(Boolean).pop();
    let isLumpSumCalculator = path === mutualFundPathName || path === 'lumpsum';

    const calculatorConstants = {
      'mutual-fund-return': {
        'totalInvestment': { // in rupees
          default: 100000,
          min: 500,
          max: 5000000
        },
        'returnRate': {   // in %
          default: 12,
          min: 1,
          max: 50
        },
        'timePeriod': {   // in yrs
          default: 5,
          min: 1,
          max: 30
        }
      },
      'sip-calculator': {
        'totalInvestment': { // in rupees
          default: 5000,
          min: 500,
          max: 5000000
        },
        'returnRate': {   // in %
          default: 12.5,
          min: 1,
          max: 50
        },
        'timePeriod': {   // in yrs
          default: 25,
          min: 1,
          max: 30
        }
      },
      'lumpsum': {
        'totalInvestment': { // in rupees
          default: 25000,
          min: 500,
          max: 5000000
        },
        'returnRate': {   // in %
          default: 12,
          min: 1,
          max: 50
        },
        'timePeriod': {   // in yrs
          default: 10,
          min: 1,
          max: 30
        }
      }
    };

    let totalInvestment = calculatorConstants[path].totalInvestment.default;
    let returnRate = calculatorConstants[path].returnRate.default;
    let timePeriod = calculatorConstants[path].timePeriod.default;

    const totalInvestmentHTML = document.getElementById('total-investment');
    const investedAmountHTML = document.getElementById('invested-amount');
    const estAmountHTML = document.getElementById('est-amount');
    const investmentTitle = document.getElementById('investment-title');

    function updateLumpsumTextValues() {

      const totalReturnValue = calculateLumpsumReturn();
      totalInvestmentHTML.innerHTML = getOuputStandard(totalReturnValue);
      investedAmountHTML.innerHTML = getOuputStandard(totalInvestment);
      estAmountHTML.innerHTML = getOuputStandard(totalReturnValue - totalInvestment);
      barChart(Number(totalInvestment), Number(totalReturnValue - totalInvestment))
    }

    function updateSIPTextValues() {
      const totalReturnValue = calculateSIPReturn();
      const totalInvestmentSIP = totalInvestment * timePeriod * 12;
      totalInvestmentHTML.innerHTML = getOuputStandard(totalReturnValue);
      investedAmountHTML.innerHTML = getOuputStandard(totalInvestmentSIP);
      estAmountHTML.innerHTML = getOuputStandard(totalReturnValue - totalInvestmentSIP);
      barChart(Number(totalInvestmentSIP), Number(totalReturnValue - totalInvestmentSIP))
    }

    function barChart(investment, returns) {
      const total = (investment + returns) / 100;
      const investmentPercent = investment / total;
      const returnsPercent = returns / total;
      updateBar('investment', minMaxBarPercent(investmentPercent));
      updateBar('returns', minMaxBarPercent(returnsPercent));
    }

    function minMaxBarPercent(value) {
      if (value < 1) {
        return 1
      } else if (value > 99) {
        return 99
      } else {
        return value
      }
    }

    function updateBar(classInfo, width) {
      const elements = document.querySelector(`.distribution-bar .${classInfo}`);
      elements.style.width = `${width * 100}%`;
    }

    function forceValueRanges(input, type, forceMin = false) {
      const value = Number(removeCharsFromString(input.val()));
      const allowedMax = calculatorConstants[mutualFundPathName][type].max;
      const allowedMin = calculatorConstants[mutualFundPathName][type].min;
      if (value > allowedMax) {
        input.val(getOuputStandard(allowedMax, input.attr('id')));
      }

      function forceMinValues() {
        if (value < allowedMin && value) {
          input.val(getOuputStandard(allowedMin, input.attr('id')));
        }
      }

      if (forceMin) {
        forceMinValues();
      }
    };

    /* Inputs */
    $('input#investment').on('input', function (event) {
      forceValueRanges($('input#investment'), 'totalInvestment');
      totalInvestment = Number(removeCharsFromString(event.target.value));
    });

    $('input#return-rate').on('input', function (event) {
      forceValueRanges($('input#return-rate'), 'returnRate');
      returnRate = Number(removeCharsFromString(event.target.value));
    });

    $('input#time-period').on('input', function (event) {
      forceValueRanges($('input#time-period'), 'timePeriod');
      timePeriod = Number(removeCharsFromString(event.target.value));
    });

    $('input[type=radio]').change(function (e) {
      path = e.target.value;
      isLumpSumCalculator = path === mutualFundPathName || path === 'lumpsum';
      updateTextValues();
      investmentTitle.innerHTML = isLumpSumCalculator ? 'Total Investment' : 'Monthly Investment';
    });

    function calculateLumpsumReturn() {
      // A = P (1 + r/n) ^ nt   .. n=1 so can ignore it
      const R = Number(returnRate) * 0.01; //return %
      const P = Number(totalInvestment); // Invested amount
      const T = Number(timePeriod);
      return Math.round(P * ((1 + R) ** T));
    }

    function calculateSIPReturn() {
      const monthlyROR = Number(returnRate) / (100 * 12);
      const months = Number(timePeriod) * 12;
      return Math.round(Number(totalInvestment) * (((((monthlyROR + 1) ** months) - 1) / monthlyROR) * (1 + monthlyROR)));
    }

    function updateTextValues() {
      isLumpSumCalculator ? updateLumpsumTextValues() : updateSIPTextValues();
    }

    function init() {
      updateTextValues();
    }

    $('.cal-slider .form-group input').on('input', function () {
      updateTextValues();
    });

    init();

    let historyOBj = []

    $('#calculate').on('click', function () {
      $('.last-three-calculations').show();
      setCalHistory(path);
    })

    function calFunction(type) {
      if (type == 'sip-calculator') {
        return calculateSIPReturn()
      } else {
        return calculateLumpsumReturn()
      }
    }

    function setCalHistory(calulatorType) {
      historyOBj.unshift({
        totalReturns: calFunction(calulatorType),
        estReturns: calFunction(calulatorType) - totalInvestment,
        investment: totalInvestment,
        interest: returnRate,
        time: timePeriod,
        type: path
      })

      if (historyOBj.length > 3) {
        historyOBj.splice(3);
      }

      let historyData = '';

      let reopenIcon = document.location.origin + '/app/themes/upstox/dist/img/mutual-funds-return/view-more-icon.svg';

      historyOBj.map(function (data, index) {
        historyData += `<div class="expected-col" ><div class="common-col history-data">
                    <h6>Invested: <span class="invest-amount-history">${getOuputStandard(data.investment)}</span></h6>
                    <h6>Expected Return: <span class="return-history">${getOuputStandard(data.totalReturns)}</span></h6>
                    <h6>Time Period: <span class="time-history">${getOuputStandard(data.time, 'time-period')}</span> </h6>
                </div>  <a href="#mutual-func-return-cal" class="mobile-last-calc history-cal" data-id="${index}">Re-open <img src="${reopenIcon}"></a></div>`
      })

      setTimeout(function () {
        $('#cal-history').html(historyData);
      }, 1500);
    }

    $(document).on('click', '.history-cal', function () {
      initializeSlider();
      const key = $(this).data('id')
      $('input#investment').val(getOuputStandard(historyOBj[key].investment, 'investment'))
      $('input#return-rate').val(getOuputStandard(historyOBj[key].interest, 'return-rate'))
      $('input#time-period').val(getOuputStandard(historyOBj[key].time, 'time-period'))
      let radioButtons = document.getElementsByName("type");
      radioButtons.forEach(function (radioButton) {
        if (radioButton.value == historyOBj[key].type) {
          radioButton.checked = true;
          return;
        }
      });
    })

    /* Start Calculator Slider Mobile */
    function initializeSlider() {
      const carouselSlides = document.querySelectorAll('.calc-slide');
      const btnNext = document.querySelector('#calculate');
      const backNext = document.querySelector('#back-button');

      let currentChild = 1;
      let currentSlide = 0;

      const getHeightOfSlide = (currentChild) => {
        let calHeight = parseInt($(`#cal-slider .calc-slide:nth-child(${currentChild}) > div`).height());
        let paddingTop = parseInt($(`#cal-slider .calc-slide:nth-child(${currentChild})`).css('padding-top'));
        let paddingBottom = parseInt($(`#cal-slider .calc-slide:nth-child(${currentChild})`).css('padding-bottom'));
        return calHeight + paddingBottom + paddingTop;
      }

      $('#cal-slider').height(getHeightOfSlide(currentChild));

      const changeSlide = function (slides) {
        carouselSlides.forEach((slide, index) => {
          let pos = 100 * (index - slides);
          if (index > 0) {
            pos = pos - 100;
          }
          return slide.style.transform = `translateX(${pos}%)`
        });
      };
      changeSlide(currentSlide);

      btnNext.addEventListener('click', function () {
        currentSlide++;
        currentChild++;
        if (carouselSlides.length - 1 < currentSlide) {
          currentSlide = 0;
        };
        changeSlide(currentSlide);
        $('#cal-slider').height(getHeightOfSlide(currentChild));
        setTimeout(function () {
          changeSlide(currentSlide + 2);
          currentChild++;
          $('#cal-slider').height(getHeightOfSlide(currentChild));
        }, 1500)

      });

      backNext.addEventListener('click', function () {
        currentSlide;
        if (carouselSlides.length - 1 < currentSlide) {
          currentSlide = 0;
        };
        changeSlide(currentSlide);

        setTimeout(function () {
          changeSlide(--currentSlide);
          --currentChild;
          $('#cal-slider').height(getHeightOfSlide(currentChild));
        }, 800)
        --currentChild;
        $('#cal-slider').height(getHeightOfSlide(currentChild));
      });
    };

    if (window.innerWidth < 767) {
      initializeSlider();
    }

    /* END Calculator Slider Mobile */

    $('.investment-main .number-tags li').on('click', function () {
      const val = $(this).attr('value');
      const investmentInputElement = $('#investment')
      currentInvestmentValue = Number(removeCharsFromString(investmentInputElement.val()))
      investmentInputElement.val(getOuputStandard(parseInt(currentInvestmentValue) + parseInt(val))).trigger('input')
    });

    $('.decrement').click(function () {
      addInput('-', $(this).next())
    });

    $('.increment').click(function () {
      addInput('+', $(this).prev())
    });

    function removeCharsFromString(string) {
      return string.replace(/[^\d.]/g, '')
    }

    function addInput(operation, inputElement) {
      const currentValue = removeCharsFromString(inputElement.val())
      const newValue = Function("return " + `${currentValue} ${operation} 1`)()
      const id = inputElement.attr('id')
      if (newValue > 0) {
        inputElement.val(getOuputStandard(newValue, id)).trigger('input')
      }
    }

    function getOuputStandard(value, id = "none") {
      if (id == 'time-period') {
        return `${value}${value > 1 ? " years" : " year"}`
      }
      else if (id == "return-rate") {
        return `${value}%`
      }
      else if (id == "investment") {
        return `₹ ${parseInt(Number(value))}`
      }
      else {
        return `₹ ${parseInt(Number(value)).toLocaleString('en-IN')}`
      }
    }

    $('.calc-slide .input').on('input', function () {
      let value = $(this).val()
      const cursorPosition = $(this)[0].selectionStart // Get the cursor position
      const id = $(this).attr('id')
      value = removeCharsFromString(value) // Remove any non-digit characters
      if (value !== '') {
        value = getOuputStandard(value, id)
      }
      $(this).val(value);
      if (id != "investment") {
        $(this)[0].setSelectionRange(cursorPosition, cursorPosition);
      }
    });
  });

  $(window).on('load', function () {
    var hash = window.location.hash;
    if ($(hash).length) {
      var target = $('#mf-app-slider');
      $('html, body').animate({
        scrollTop: target.offset().top - 20
      }, 10);
    }
  });

})(jQuery);


